// Expose various shared variables across all modules
var ConnectGlobals = {
    connectVersion: '',
    minVersion: '',
    sessionId: '',
    sessionKey: ''
};
export { ConnectGlobals };
